module.exports = __webpack_public_path__ + "images/b9e351729b79d347032e083ddcac7d5b.svg";